import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { REGISTER_API, LOGIN_API, GET_ME_API, LOGOUT_API } from "./Api";
import Axios from "./Api";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

// Flexible: teeno tarike se call kar sakte ho -
//   formatApiError(err)            -> raw Axios error (err.response.data...)
//   formatApiError(err?.detail)    -> apiRequest() wrapper se already-extracted detail
//   formatApiError("some string")  -> plain string
export const formatApiError = (error) => {
  let detail = error;
  if (error && typeof error === "object") {
    if (error.response?.data !== undefined) {
      // raw Axios error
      detail = error.response.data.detail ?? error.response.data.message ?? error.response.data;
    } else if ("detail" in error) {
      // our apiRequest() wrapper's Error object
      detail = error.detail;
    }
  }

  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Backward-compat: kuch purane components (jaise RegistrationDialog.jsx)
// ab bhi "apiRequest" import karte hain. path/method/body same purane
// shape me lete hain, andar se Axios (api.js) use karta hai.
// token param optional hai — api.js ka interceptor waise bhi localStorage
// se token khud utha leta hai, isliye zaroori nahi.
export const apiRequest = async (path, { method = "GET", body, token } = {}) => {
  const headers = {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  try {
    const res = await Axios.request({
      url: path.replace(/^\//, ""), // "/auth/register/" -> "auth/register/"
      method,
      data: body,
      headers,
    });
    return res.data;
  } catch (error) {
    const err = new Error("Request failed");
    err.detail = error?.response?.data?.detail;
    err.status = error?.response?.status;
    throw err;
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  

  // api.js ka interceptor localStorage se token khud utha leta hai,
  // isliye yahan alag se token pass karne ki zaroorat nahi
  const refreshUser = useCallback(async () => {
    try {
      const res = await GET_ME_API();

      setUser(res.data);
      setAuthenticated(true); 

      return res.data;        
    } catch (err) {
      setUser(null);
      setAuthenticated(false);

      return null;
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  // ---- Normal email/password register + login (api.js se) ----

  const register = async (body) => {
    const res = await REGISTER_API(body);
    return res.data;
  };

  const login = async (body) => {
    const res = await LOGIN_API(body);

    // Backend cookie set kar chuka hai
    await refreshUser();

    return res.data;
  };

  
  const loginWithSSO = () => {
    window.location.href = `${API}/auth/login`;
  };
  const completeSSOLogin = async () => {
    return await refreshUser();
  };
  const logout = async () => {
    try {
      await LOGOUT_API();
    } finally {
      setUser(null);
      setAuthenticated(false);
    }
  };
  const value = {
    user,
    setUser,
    loading,
    authenticated,
    register,
    login,
    loginWithSSO,
    completeSSOLogin,
    logout,
    refreshUser,
    API,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};